import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { OfframpService } from '../../services/offramp.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50
  }
};

@Component({
  selector: 'app-add-offramp-client-quote',
  templateUrl: './add-offramp-client-quote.component.html',
  styleUrls: ['./add-offramp-client-quote.component.css']
})
export class AddOfframpClientQuoteDialog implements OnInit {
  element: any = {};
  myForm: any;
  clientList: any[] = [];
  isEditMode: boolean = false;
  recordId: string = '';
  currentUserDisplay: string = '';

  constructor(
    public dialogRef: MatDialogRef<AddOfframpClientQuoteDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notifSer: NotificationsService,
    public fb: FormBuilder,
    public userService: UserService,
    public offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.element = data.record || {};
    this.isEditMode = !!this.element._id;
    this.recordId = this.element._id || '';

    const loggedInUser = this.userService.getUserDetails();
    this.currentUserDisplay = loggedInUser ? `${loggedInUser.name} (${loggedInUser.email})` : '';

    this.myForm = this.fb.group({
      adminid: [
        this.element.adminid ? (this.element.adminid._id || this.element.adminid) : (loggedInUser ? loggedInUser._id : ''),
        [Validators.required]
      ],
      client_id: [
        this.element.client_id ? (this.element.client_id._id || this.element.client_id) : ''
      ],
      from_currency: [this.element.from_currency || '', [Validators.required]],
      to_currency: [this.element.to_currency || '', [Validators.required]],
      rate: [this.element.rate || 0, [Validators.required, Validators.min(0)]],
      delta: [this.element.delta || 0],
      status: [this.element.status || 'New', [Validators.required]],
      communication_status: [this.element.communication_status || 'New', [Validators.required]],
    });
  }

  ngOnInit() {
    this.loadClientList();
  }

  loadClientList() {
    const filter = {
      _csrf: this.data._csrf,
      perpage: 10000,
      page: 1,
      search: '',
      status: 'Active',
    };

    this.offrampService.getOfframpCustomerList(filter).subscribe(
      (response: any) => {
        if (response && response.customers && Array.isArray(response.customers)) {
          this.clientList = response.customers;
        } else if (response && Array.isArray(response)) {
          this.clientList = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          this.clientList = response.data;
        } else {
          this.clientList = [];
        }
      },
      () => {
        this.notifSer.error('Error', 'Failed to load client list', defaults.notif);
        this.clientList = [];
      }
    );
  }

  saveQuote() {
    const { notif } = defaults;

    if (this.myForm.invalid) {
      this.notifSer.error('Error', 'Please fill all required fields', notif);
      return;
    }

    this.spinnerService.show();

    const formData: any = {
      ...this.myForm.value,
      _csrf: this.data._csrf
    };

    if (this.isEditMode) {
      formData._id = this.recordId;
      this.offrampService.updateOfframpClientQuote(formData).subscribe(
        (response) => {
          this.spinnerService.hide();
          if (response.status || response.success) {
            this.notifSer.success('Success', response.message || 'Quote updated successfully', notif);
            this.dialogRef.close({ success: true, data: response });
          } else {
            this.notifSer.error('Error', response.message || 'Failed to update quote', notif);
          }
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to update quote', notif);
        }
      );
    } else {
      this.offrampService.createOfframpClientQuote(formData).subscribe(
        (response) => {
          this.spinnerService.hide();
          if (response.status || response.success) {
            this.notifSer.success('Success', response.message || 'Quote created successfully', notif);
            this.dialogRef.close({ success: true, data: response });
          } else {
            this.notifSer.error('Error', response.message || 'Failed to create quote', notif);
          }
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to create quote', notif);
        }
      );
    }
  }

  onCancel() {
    this.dialogRef.close({ success: false });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-client-quotes/add-offramp-client-quote/add-offramp-client-quote.component.ts